import { lazy } from "react";

const Dashboard = lazy(() => import("../pages/Dashboard/Dashboard.js"));
const AddressInfo = lazy(() => import("../pages/TableList/AddressInfo"));
const BankInfo = lazy(() => import("../pages/TableList/BankInfo"));
const Personal = lazy(() => import("../pages/Shareholders/Personal"));
const LawyerRequestsComponent = lazy(() =>
  import("../pages/LawyerRequests/LawyerRequests")
);
const StockRequestsComponent = lazy(() =>
  import("../pages/StocksRequests/StockRequests")
);
// const BankPayments = lazy(() => import("../pages/HaghTaghadom/Bank"));
const UploadFileMain = lazy(() => import("../pages/Upload"));
const FileBuilderForm = lazy(() =>
  import("../pages/HaghTaghadom/FormFileBuilder/FileFormBuilder")
);
const ReceiveBetter = lazy(() => import("../pages/Message/ReceiveBetter"));
const FileLog = lazy(() => import("../pages/History/FileLog"));
const ContradictionScreen = lazy(() => import("../pages/Contradiction"));
const SendingTicket = lazy(() => import("../pages/TicketScreen/SendingTicket"));
const TicketScreen = lazy(() => import("../pages/TicketScreen"));
const HistoryScreen = lazy(() => import("../pages/History/History"));
const ShebaMeli = lazy(() => import("../pages/Services/ShebaMeli"));
const Sheba = lazy(() => import("../pages/Services/Sheba"));
// const AuthScreen = lazy(() => import("../pages/Services/AuthScreen"));
const Credit = lazy(() => import("../pages/Services/Credit"));
const Shahkar = lazy(() => import("../pages/Services/Shahkar"));
const ContactUs = lazy(() => import("../pages/ContactUs"));
const AboutCompany = lazy(() => import("../pages/AboutCompany"));
const FileMaker = lazy(() =>
  import("../pages/HaghTaghadom/FileMaker/FileMaker")
);
const BuyingWithFish = lazy(() =>
  import("../pages/HaghTaghadom/BuyingWithFish")
);
const Buying = lazy(() => import("../pages/HaghTaghadom/Buying"));
const Agree = lazy(() => import("../pages/HaghTaghadom/Agree"));
const Disagree = lazy(() => import("../pages/HaghTaghadom/Disagree"));
const Main = lazy(() => import("../pages/HaghTaghadom/Main"));
const SahamdaranScreen = lazy(() => import("../pages/SahamdaranScreen"));
const Members = lazy(() => import("../pages/Members"));
const Admins = lazy(() => import("../pages/Admins"));
const CreateReport = lazy(() => import("../pages/UnusedStock/CreateReport"));
const PreviousReports = lazy(() => import("../pages/UnusedStock/PreviousReports"));
const BatchFile = lazy(() => import("../pages/HaghTaghadom/BatchFile"));
const SendSMS = lazy(() => import("../pages/SMS/SendSMS"));
const SMSHistory = lazy(() => import("../pages/SMS/SMSHistory"));

const routes = [
  {
    path: "/",
    component: Dashboard,
  },
  {
    path: "/sahamdaran",
    component: SahamdaranScreen,
  },
  {
    path: "/history",
    component: HistoryScreen,
  },
  {
    path: "/Upload",
    component: UploadFileMain,
  },
  {
    path: "/fileLog/:id",
    component: FileLog,
  },
  {
    path: "/personal",
    component: Personal,
  },
  {
    path: "/bank",
    component: BankInfo,
  },
  {
    path: "/address",
    component: AddressInfo,
  },
  {
    path: "/contradiction/:id",
    component: ContradictionScreen,
  },
  {
    path: "/stockrequests",
    component: StockRequestsComponent,
  },
  {
    path: "/lawyerrequests",
    component: LawyerRequestsComponent,
  },
  {
    path: "/priority",
    component: Main,
  },
  {
    path: "/disagree",
    component: Disagree,
  },
  {
    path: "/agree",
    component: Agree,
  },
  {
    path: "/buying",
    component: Buying,
  },
  {
    path: "/buyingfish",
    component: BuyingWithFish,
  },
  /*{
    path: "/bankpayments",
    component: BankPayments,
  },*/
  {
    path: "/filemaking",
    component: FileMaker,
  },
  {
    path: "/formbuilder",
    component: FileBuilderForm,
  },

  {
    path: "/messageBetter",
    component: ReceiveBetter,
  },
  {
    path: "/about",
    component: AboutCompany,
  },
  {
    path: "/service",
    component: Shahkar,
  },
  {
    path: "/shahkar/:nin/:mobile",
    component: Shahkar,
  },
  /*{
    path: "/auth/:nin/:mobile",
    component: AuthScreen,
  },*/
  {
    path: "/sheba/:shebaNumber",
    component: Sheba,
  },
  {
    path: "/shebaMeli/:nin/:sheba",
    component: ShebaMeli,
  },
  {
    path: "/credit",
    component: Credit,
  },

  {
    path: "/ticket",
    component: TicketScreen,
  },
  {
    path: "/sending",
    component: SendingTicket,
  },

  {
    path: "/contactUs",
    component: ContactUs,
  },
  {
    path: "/members",
    component: Members,
  },
  {
    path: "/admins",
    component: Admins,
  },
  {
    path: "/createReport",
    component: CreateReport,
  },
  {
    path: "/previousReports",
    component: PreviousReports,
  },
  {
    path: "/batchfile",
    component: BatchFile,
  },
  {
    path: "/sendsms",
    component: SendSMS,
  },
  {
    path: "/smshistory",
    component: SMSHistory,
  },
];

export default routes;
